import {Linking} from 'react-native';

export const openLinkSafe = async (url: string) => {
  try {
    await Linking.openURL(url);
  } catch (error) {
    // ignore error
  }
};
